import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { get } from 'lodash-es'
import { Helmet } from 'react-helmet'
import { stringUtils } from '../../../../utils'
import logo from '../../../../theme/images/logo.svg'
import { Card, Layout, LayoutHeader, LayoutBody, SignupForm } from '../../../components'
import styles from './SignupPage.module.scss'

interface SignupInvite {
  firstName?: string
  email?: string
}

interface Location {
  search: string
  state?: {
    from?: string
  }
}

interface SignupPageProps {
  isAuthenticated?: boolean
  location: Location
  loginRedirect: React.MouseEventHandler<HTMLButtonElement>
  getInvite: (token: string) => void
  signupInvite?: SignupInvite
}

const SignupPage = ({
  isAuthenticated,
  location,
  loginRedirect,
  getInvite,
  signupInvite,
}: SignupPageProps): null | React.ReactElement => {
  const getToken = (): undefined | string => {
    const query = stringUtils.parseQueryString(location.search.replace('?', ''))
    const token = get(query, 'token', false)
    /**
     * @@todo HACK - re-add '==' because parseQueryString splits string by '='
     */
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    return token ? `${token as string}==` : undefined
  }

  useEffect(() => {
    const token = getToken()
    if (token !== undefined) {
      getInvite(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const from = location && location.state && location.state.from
  const from = location?.state?.from !== undefined ? location.state.from : '/'

  const firstName = get(signupInvite, 'firstName')
  const email = get(signupInvite, 'email')

  return Boolean(isAuthenticated) ? (
    <Redirect to={from} />
  ) : (
    <div className={styles.root}>
      <Helmet>
        <title>reOS | Sign up</title>
      </Helmet>
      <Layout>
        <LayoutHeader>
          <div className={styles.header}>
            <img width="96px" src={logo} alt="reOS" />
          </div>
        </LayoutHeader>
        <LayoutBody>
          <div className={styles['form-container']}>
            <div style={{ width: '360px' }}>
              <Card on>
                <SignupForm firstName={firstName} email={email} encryptedValue={getToken()} />
              </Card>
              <p className={styles.footer}>
                Already have an account?{' '}
                <button type="button" onClick={loginRedirect}>
                  Sign in
                </button>
              </p>
            </div>
          </div>
        </LayoutBody>
      </Layout>
    </div>
  )
}

export default SignupPage
